/**
 * 向 URI 追加查询参数
 * 
 * 将查询参数追加到 URI 中，如果 URI 已有查询参数，会合并新的参数。
 * 
 * @param uri 原始 URI 字符串
 * @param query 要追加的查询参数对象
 * @returns 追加查询参数后的完整 URI 字符串
 * @example
 * ```typescript
 * appendUri('wss://example.com/live', { ticket: 'abc123', force: 1 })
 * // 返回: 'wss://example.com/live?ticket=abc123&force=1'
 * 
 * appendUri('wss://example.com/live?room=1', { ticket: 'abc123' })
 * // 返回: 'wss://example.com/live?room=1&ticket=abc123'
 * ```
 */
export function appendUri(uri: string, query: Record<string, string | number> = {}) {
  const url = new URL(uri, 'http://localhost') // 使用一个虚拟的基地址
  const searchParams = new URLSearchParams(url.search)

  for (const [key, value] of Object.entries(query)) {
    searchParams.set(key, String(value))
  }

  const qs = searchParams.toString()
  const base = uri.split('#')[0].split('?')[0]
  const hash = url.hash ?? ''
  return `${base}${qs ? `?${qs}` : ''}${hash}`
}
